import { Component, OnInit, inject } from '@angular/core';
import { HeaderLayoutComponent } from '../header-layout/header-layout.component';
import { SidebarLayoutComponent } from '../sidebar-layout/sidebar-layout.component';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-content-layout',
  standalone: true,
  imports: [
    HeaderLayoutComponent,
    SidebarLayoutComponent,
    BottomNavComponent,
    RouterModule,
    CommonModule,
  ],
  templateUrl: './content-layout.component.html',
  styleUrl: './content-layout.component.css',
  providers: [],
})
export class ContentLayoutComponent implements OnInit {
  ngOnInit(): void { }
}
